
import { defineComponent } from 'vue';
import Modal from '@/shared/mixins/Modal';

export default defineComponent({
  name: 'AdModal',
  mixins: [Modal],
  emits: ['close'],
   props: {
    title: {
      type: String,
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
});
